import React, {useEffect, useState} from 'react'
import bookmark from '../../../../media/resources/icons/ic-bookmark.svg'
import bookmarkActive from '../../../../media/resources/icons/ic-bookmark-active.svg'
import {useIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import {createFounderMarketBookmarks} from '../core/_requests'
import {useAuth} from '../../auth'
import {toast} from 'react-toastify'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../hooks/gtmHelpers'

export default function DealsFullWidthCard({
  id,
  title,
  type,
  category,
  image,
  description,
  showCategories,
  deal,
  bookmarked,
  getAllFounderMarketDeals,
}: any) {
  const [isBookmarked, setIsBookmarked] = useState<boolean>(bookmarked)
  const {companyId, currentUser} = useAuth()

  useEffect(() => {
    setIsBookmarked(bookmarked)
  }, []) // eslint-disable-line

  const handleBookmarkClick = () => {
    createFounderMarketBookmark(deal)
  }

  const [shortDescription, setShortDescription] = useState('')
  const {formatMessage} = useIntl()

  useEffect(() => {
    // Slice the description to 150 characters when it changes
    setShortDescription(description.slice(0, 180))
  }, [description])

  const createFounderMarketBookmark = async (dealId: any) => {
    try {
      if (companyId) {
        const {
          data: {data: bookmarkRes, errors, success},
        } = await createFounderMarketBookmarks(companyId, dealId)
        if (success) {
          // getAllFounderMarketDeals()
          setIsBookmarked(!isBookmarked)
          console.log(bookmarkRes, 'book data')
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.FounderMarketBookmarked,
              action: 'normal',
              metadata: {
                deal_id: dealId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
                title: title || '',
                type: type || '',
                category: category || '',
                book_marked: !isBookmarked,
              },
            },
          })
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.FounderMarketBookmarkFailed,
              action: 'normal',
              metadata: {
                deal_id: dealId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
                error: errors[0],
                title: title || '',
                type: type || '',
                category: category || '',
                book_marked: isBookmarked,
              },
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  const hrefValue = type === 'deals' ? `/founder-market/tools-platform-offers/${id}` : '#'

  return (
    <div className='mb-4 rounded-2'>
      <div className='p-0'>
        <div className='d-flex flex-column justify-content-between flex-md-row align-items-center'>
          <div className='documents-card-v2 flex-grow-1 bg-white w-100'>
            <div className={`d-flex flex-column flex-md-row justify-self-start cardLayout`}>
              <Link to={hrefValue} aria-disabled={type !== 'deals'} className='doc-image'>
                <img src={image} alt='documents thumbnail' className={`d-flex `} />
              </Link>

              <div className='d-flex flex-column justify-content-between p-4 w-100'>
                <div className='d-flex flex-column w-100'>
                  <div className='d-flex justify-content-between align-items-center mb-4'>
                    <p
                      className='px-4 py-1 font-size-14 mb-0'
                      style={{borderRadius: '80px', border: '1px solid #CFE0FA'}}
                    >
                      {category}
                    </p>
                    <button onClick={handleBookmarkClick} className='border-0 bg-transparent'>
                      <img src={isBookmarked ? bookmarkActive : bookmark} alt='bookmark icon' />
                    </button>
                  </div>

                  <h5 className='font-size-16'>{title}</h5>
                  <p className='font-size-12 mt-2'>{shortDescription}...</p>
                </div>
                <div className='d-flex justify-content-end'>
                  <Link
                    to={hrefValue}
                    aria-disabled={type !== 'deals'}
                    className='btn btn-primary cta-documents'
                  >
                    {formatMessage({id: 'Know More'})}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
